/** A visible reply invokes its chip handler, including non-message actions such as Done. */
export interface ChatSuggestedAction {
  select: () => void;
  disabled?: boolean;
}

/** Typed text wins. Empty input is unambiguous only with one visible, enabled reply. */
export function singleChatSuggestedAction(
  message: string,
  actions: readonly ChatSuggestedAction[]
): ChatSuggestedAction | null {
  if (message.trim() || actions.length !== 1) return null;
  const action = actions[0];
  return action && !action.disabled ? action : null;
}

/** Return may accept a sole reply, but composition and modified Return retain text-entry semantics. */
export function isPlainChatReturn(event: KeyboardEvent): boolean {
  return (
    !event.isComposing &&
    event.keyCode !== 229 &&
    !event.shiftKey &&
    !event.ctrlKey &&
    !event.metaKey &&
    !event.altKey
  );
}

/**
 * cas-bd8f (Ben 2026-10-05 22:13Z): "clicking Command+Enter should submit". Cmd+Enter
 * (macOS) or Ctrl+Enter (elsewhere) sends a chat composer exactly like its send
 * button; plain Enter and Shift+Enter keep making a new line. An IME composition
 * Enter and a held-down key's auto-repeat never send.
 */
export function isChatSubmitShortcut(event: KeyboardEvent): boolean {
  return (
    event.key === 'Enter' &&
    (event.metaKey || event.ctrlKey) &&
    !event.altKey &&
    !event.repeat &&
    !event.isComposing &&
    event.keyCode !== 229
  );
}
